/**
 * Wording and number format shared by the Your Plan screen and its report, so both print the same
 * figure the same way: whole dollars, and "Fully covered" rather than a $0 gap.
 */
import { formatCurrency } from '@shared';

export function formatPlanMoney(value: number): string {
  return formatCurrency(Math.round(value));
}

export const YOUR_PLAN_LABELS = {
  estimatedCost: 'Estimated long-term care cost',
  selfFunding: 'Covered by your savings and income',
  policyTotal: 'Covered by insurance and other policies',
  combined: 'Total Projected Coverage',
  gap: 'Remaining gap',
} as const;

export const FULLY_COVERED = 'Fully covered';
export const POLICY_NOT_COUNTED = 'Needs an updated quote, not counted';

export function isFullyCovered(gap: number): boolean {
  return Math.round(gap) === 0;
}

export function formatPlanGap(gap: number): string {
  return isFullyCovered(gap) ? FULLY_COVERED : formatPlanMoney(gap);
}

export function formatPolicyCoverage(projectedCoverage: number | null): string {
  return projectedCoverage === null ? POLICY_NOT_COUNTED : formatPlanMoney(projectedCoverage);
}

export function formatSubmittedOn(submittedAt: string): string {
  return new Date(submittedAt).toLocaleDateString('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  });
}
